/**
 * User Authority.
 */
export enum UserAuthority {

  /**
   * Authority to <strong>READ</strong> any dealer information.
   *
   * <p>
   *     User having this authority is able to <strong>READ</strong> any dealer information, like:
   *     <ul>
   *         <li>Profile</li>
   *         <li>Report Log</li>
   *         <li>Species/Transaction Reports</li>
   *     </ul>
   * </p>
   * <p>
   *     Such a user is also able to search for any dealers.
   * </p>
   */
  DEALER_INFO,

  /**
   * Authority to <strong>ADD, DELETE or UPDATE</strong> report for any dealer.
   */
  MANAGE_REPORT,

  /**
   * Authority to <strong>ADD COMMENT</strong> for any dealer.
   */
  MANAGE_PROFILE,

  /**
   * Authority to <strong>READ</strong> currently logged in dealer information.
   *
   * <p>
   *     User having this authority is able to <strong>READ</strong> any of the information related to himself, like:
   *     <ul>
   *         <li>Profile</li>
   *         <li>Report Log</li>
   *         <li>Species/Transaction Reports</li>
   *         <li>add/delete/update his purchase reports</li>
   *     </ul>
   * </p>
   */
  MY_INFO,
  MANAGE_MY_REPORT,

  INDUSTRY_REPORT,
  QUERY_REPORT,
  MY_QUERY_REPORT,
  MY_INDUSTRY_REPORT,

  MANAGE_BULK_IMPORT
}

export namespace UserAuthority {

  export function fromString(name: string): UserAuthority {
    return UserAuthority[name];
  }

}
